module.exports = __webpack_public_path__ + "static/media/warning-light.c1efcf9b.svg";